import axios from 'axios';
import { CommentaryTypeLabel } from '../../../../commentary/commentary.types';

export type GetCommentaryResponse = {
  author: string;
  dateHtml: string;
  format: 'HTML' | 'PDF';
  sourceName: string;
  title: string;
  url: string;
} & (
  | { typeLabel: CommentaryTypeLabel.HYBRID }
  | { typeLabel: CommentaryTypeLabel.OPEN }
  | { typeLabel: CommentaryTypeLabel.PAPER }
);

export function getCommentariesUrls(
  docId: string,
  query: string,
): Promise<{ data: Array<GetCommentaryResponse> }> {
  return axios.get(`/api/decisions/${docId}/commentaries`, {
    params: {
      q: query,
    },
  });
}
